import React, { useEffect, useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { materialLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import "./App.css";

const App = () => {
  const [selectedFile, setSelectedFile] = useState("smelly-66.json"); // Default file
  const [codeData, setCodeData] = useState({});
  const [currentIndex, setCurrentIndex] = useState(1); // Start with object "1"

  // Fetch the JSON file
  const fetchJSONFile = (fileName) => {
    fetch(`/assets/${fileName}`)
      .then((response) => {
        if (!response.ok) throw new Error("Failed to load JSON file");
        return response.json();
      })
      .then((data) => setCodeData(data)) // Set the entire JSON object
      .catch((error) => console.error("Error loading JSON:", error));
  };

  // Fetch the default JSON file when the app loads
  useEffect(() => {
    fetchJSONFile(selectedFile);
  }, [selectedFile]);

  // Handle menu selection for files
  const handleFileChange = (event) => {
    setSelectedFile(event.target.value);
    setCurrentIndex(1); // Reset to the first object when switching files
  };
  //https://github.com/apache/commons-lang/tree/351fb75f495c4b9e683486ff11517855315729f9

  // Navigation between objects
  const handleNext = () => {
    if (currentIndex < Object.keys(codeData).length) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 1) {
      setCurrentIndex((prev) => prev - 1);
    }
  };
  const openTestClassLink= (testPath)=>{
    let basePath="https://github.com/apache/commons-lang/tree/351fb75f495c4b9e683486ff11517855315729f9/"
    let srcSuffix="src/test/java/org/apache/commons/lang3/"
    window.open(basePath, '_blank');
  };

  // Get the current code object
  const currentCode = codeData[currentIndex] || {};

  return (
    <div className="app">
      <h1>Smelly vs Refactored Testcases from <a href="https://github.com/apache/commons-lang/tree/351fb75f495c4b9e683486ff11517855315729f9" target="_blank">Apache/commons-lang</a> </h1>

      {/* Dropdown menu for selecting JSON files */}
      <div className="menu">
        <label htmlFor="file-selector">Select the Sample Dataset: </label>
        <select
          id="file-selector"
          value={selectedFile}
          onChange={handleFileChange}
        >
          <option value="smelly-66.json">Smelly-66</option>
          <option value="smelly-79-AR.json">Smelly-79-AR</option>
        </select>
      </div>

      {/* Navigation Buttons */}
      <div className="navigation">
        <button onClick={handlePrevious} disabled={currentIndex <= 1}>
          Previous
        </button>
        <span> Testcase {currentIndex} of {Object.keys(codeData).length}</span>
        <button
          onClick={handleNext}
          disabled={currentIndex >= Object.keys(codeData).length}
        >
          Next
        </button>
      </div>

      {/* Code Display */}
      <div className="code-container">
        <div className="code-snippet">
          <h2>Smelly Test</h2>
          <h3> {currentCode.testcase}</h3>
          <SyntaxHighlighter language="java" style={materialLight}>
            {currentCode.smelly
              ? currentCode.smelly // Remove markdown
              : "// No smelly code available"}
          </SyntaxHighlighter>
        </div>
        <div className="code-snippet">
          <h2>Refactored Test</h2>
          <h3>{currentCode.testcase}</h3>
          <SyntaxHighlighter language="java" style={materialLight}>
            {currentCode.refactored
              ? currentCode.refactored // Remove markdown
              : "// No refactored code available"}
          </SyntaxHighlighter>
        </div>
      </div>
    </div>
  );
};

export default App;
